import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useState } from "react";
import { MobileTimePicker } from "@mui/x-date-pickers";

const TimePickerField = ({
  name,
  formik,
  label,
  time,
  chnageTourHandler,
  reqiuerd,
}) => {
  const [value, setValue] = useState("");
  const createDateFromTextValue = (value) => {
    const splitParts = value.split(":");
    return new Date(1970, 1, 1, splitParts[0], splitParts[1]);
  };
  const initTime = createDateFromTextValue(`${time}`);
  return (
    <div className="flex flex-col h-24">
      <label className="mb-2 text-xs md:text-sm">
        {label} {reqiuerd ? <span className="text-red-700">*</span> : ""}
      </label>
      <LocalizationProvider dateAdapter={AdapterDateFns} className="h-10">
        <MobileTimePicker
          ampm={false}
          name={name}
          toolbarTitle={label}
          value={value ? value : initTime}
          onChange={(newValue) => {
            setValue(newValue);
            const hours = newValue.getHours().toString().padStart(2, "0");
            const minutes = newValue.getMinutes().toString().padStart(2, "0");
            const textValue = hours + ":" + minutes;
            chnageTourHandler(name, textValue);
            formik.setFieldValue(name, textValue);
          }}
          renderInput={(params) => <TextField {...params} />}
        />
      </LocalizationProvider>
    </div>
  );
};
export default TimePickerField;
